import { Spinner, Alert, Progress, Badge } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { usePodClusters } from './usePodClusters';

function usedPct(free, total) {
  if (!total || total <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round(((total - free) / total) * 100)));
}
function barColor(pct) {
  return pct >= 90 ? 'danger' : pct >= 70 ? 'warning' : 'success';
}

/**
 * Operator-Cluster-Dashboard (#7): aktive Pod-Hosting-Cluster mit freier
 * Kapazität (allocatable minus Pod-Requests) + Pod-Anzahl je Cluster/Region.
 */
export function PodClustersPage() {
  const query = usePodClusters();
  const clusters = query.data?.clusters ?? [];

  return (
    <div>
      <PageHeader title="Pod-Cluster" />
      <p className="text-muted">Kapazität &amp; Auslastung der Hosting-Cluster (Aktualisierung alle 30 s).</p>

      {query.isLoading && <Spinner />}
      {query.error && <Alert color="danger">Cluster-Kapazität konnte nicht geladen werden.</Alert>}
      {query.data && query.data.enabled === false && (
        <Alert color="info">Nexus ist nicht konfiguriert (NEXUS_API_URL fehlt).</Alert>
      )}
      {query.data && clusters.length === 0 && query.data.enabled !== false && (
        <Alert color="secondary">Keine aktiven Cluster registriert.</Alert>
      )}

      <div className="row">
        {clusters.map((c) => {
          const cap = c.capacity;
          const cpuPct = cap ? usedPct(cap.freeCpuMillicores, cap.cpuMillicores) : 0;
          const ramPct = cap ? usedPct(cap.freeRamMb, cap.ramMb) : 0;
          return (
            <div className="col-md-6" key={c.slug}>
              <div className="card mb-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      {c.name}{' '}
                      {c.is_default && <Badge color="primary" pill>default</Badge>}
                    </h5>
                    <span className="text-muted">{c.region}</span>
                  </div>
                  <div className="text-muted small mb-3">
                    {c.provider || 'k8s'} · {c.pods} Pod{c.pods === 1 ? '' : 's'} · <code>{c.slug}</code>
                  </div>

                  {cap ? (
                    <>
                      <div className="d-flex justify-content-between small">
                        <span>CPU</span>
                        <span>{cap.reservedCpuMillicores}m / {cap.cpuMillicores}m · frei {cap.freeCpuMillicores}m</span>
                      </div>
                      <Progress value={cpuPct} color={barColor(cpuPct)} className="mb-2" />
                      <div className="d-flex justify-content-between small">
                        <span>RAM</span>
                        <span>{cap.reservedRamMb}Mi / {cap.ramMb}Mi · frei {cap.freeRamMb}Mi</span>
                      </div>
                      <Progress value={ramPct} color={barColor(ramPct)} />
                    </>
                  ) : (
                    <Alert color="warning" className="mb-0 py-2">Kapazität nicht abrufbar (k8s-API nicht erreichbar).</Alert>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
